import InputDate from "components/atoms/InputDate";
import InputRadio from "components/atoms/InputRadio";
import InputSelect from "components/atoms/InputSelect";
import { BreadcrumbNav } from "components/molecules";
import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import { ArrowDown, ArrowUp } from "react-feather";
import { useSelector } from "react-redux";
import { MonthOptions, Source, UserLevel } from "utils/constant";
import { generateMonthOptions } from "utils/common";
import Wilayah from "services/Wilayah";
import Fasyankes from "services/Fasyankes";
import Laporan from "services/Laporan";
import BKK from "services/BKK";
import Button from "components/atoms/Button";
import { HashLoader } from "react-spinners";
import TableComponent from "./Table";
import { exportToExcel } from "utils/exportExcel";
import { useHistory } from "react-router-dom";
import Pagination from "components/Pagination";

const WilayahService = new Wilayah();
const FasyankesService = new Fasyankes();
const LaporanService = new Laporan();
const BKKService = new BKK();

const DetailLaporan = () => {
  const module = "Regmal 1";

  const { currentUser } = useSelector((state) => state.authReducer);
  const [isDownloading, setIsDownloading] = useState(false);
  const tableRef = useRef(null);
  const history = useHistory();

  const [reportData, setReportData] = useState([]);
  const [showFilter, setShowFilter] = useState(true);
  const [showData, setShowData] = useState(false);
  const [levelData, setLevelData] = useState([]);
  const [selectedLevel, setSelectedLevel] = useState(currentUser.level);
  const [currentLevel, setCurrentLevel] = useState("");
  const [levelIdValue, setLevelIdValue] = useState("");
  const [levelDataOptions, setLevelDataOptions] = useState({
    provinces: [],
    districts: [],
    fasyankes: [],
    induks: [],
    wilkers: [],
  });
  const [selectedProvince, setSelectedProvince] = useState(
    currentUser?.province_id
  );
  const [selectedDistrict, setSelectedDistrict] = useState(
    currentUser?.district_id
  );
  const [selectedFasyankes, setSelectedFasyankes] = useState(
    currentUser?.fasyankes_id
  );
  const [selectedInduk, setSelectedInduk] = useState("");
  const [selectedWilker, setSelectedWilker] = useState("");
  const [periodeLaporan, setPeriodeLaporan] = useState("");
  const [periodeLaporanValue, setPeriodeLaporanValue] = useState("");
  const [selectedEnd, setSelectedEnd] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const [reportInfo, setReportInfo] = useState({});

  const fetchAllProvincies = async () => {
    try {
      const response = await WilayahService.getAll(Source.PROVINCE, {
        page: 1,
        limit: 9999,
      });
      setLevelDataOptions((prevState) => ({
        ...prevState,
        provinces: response.province.map((item) => {
          return {
            label: item.name,
            value: `${item.id}|${item.name}`,
          };
        }),
      }));
    } catch (error) {
      console.log(error);
    }
  };

  const fetchDistrictByProvince = async (provinceId) => {
    try {
      const response = await WilayahService.getAll(Source.DISTRICT, {
        page: 1,
        limit: 9999,
        searchBy: "province_id",
        searchValue: provinceId,
      });

      setLevelDataOptions((prevState) => ({
        ...prevState,
        districts: response.district.map((item) => {
          return {
            label: item.name,
            value: `${item.id}|${item.name}`,
          };
        }),
      }));
    } catch (error) {
      console.log(error);
    }
  };

  const fetchFasyankesByDistrict = async (districtId) => {
    try {
      const response = await FasyankesService.getAll(Source.FASYANKES, {
        page: 1,
        limit: 9999,
        searchBy: "district_id",
        searchValue: districtId,
      });

      setLevelDataOptions((prevState) => ({
        ...prevState,
        fasyankes: response.fasyankes.map((item) => {
          return {
            label: item.name,
            value: `${item.id}|${item.name}`,
          };
        }),
      }));
    } catch (error) {
      console.log(error);
    }
  };

  const fetchBKKInduk = async () => {
    try {
      const response = await BKKService.getAll({
        page: 1,
        limit: 9999,
        province_id:
          selectedProvince?.split("|")[0] ||
          (currentUser?.level === UserLevel.Province
            ? currentUser.province_id?.split("|")[0]
            : ""),
        district_id:
          selectedDistrict?.split("|")[0] ||
          (currentUser?.level === UserLevel.District
            ? currentUser.district_id?.split("|")[0]
            : ""),
      });

      const bkkList = response.bkk || [];
      const induks = bkkList.filter((item) => !item.induk_id);

      setLevelDataOptions((prevState) => ({
        ...prevState,
        induks: induks.map((item) => {
          return {
            label: item.name,
            value: `${item.id}|${item.name}`,
          };
        }),
      }));
    } catch (error) {
      console.log(error);
    }
  };

  const fetchBKKWilker = async (indukIds) => {
    try {
      const params = {
        page: 1,
        limit: 9999,
      };
      const ids = (indukIds || "")
        .split(",")
        .map((item) => item.split("|")[0].trim())
        .filter(Boolean);

      if (!ids.length) {
        if (
          currentUser.level !== UserLevel.District &&
          currentUser.level !== UserLevel.Province
        ) {
          setLevelDataOptions((prevState) => ({ ...prevState, wilkers: [] }));
          return;
        }
        params.province_id =
          selectedProvince?.split("|")[0] ||
          (currentUser?.level === UserLevel.Province
            ? currentUser.province_id?.split("|")[0]
            : "");
        params.district_id =
          selectedDistrict?.split("|")[0] ||
          (currentUser?.level === UserLevel.District
            ? currentUser.district_id?.split("|")[0]
            : "");
      }

      // Wilker is fully determined by induk_id, so no province/district
      // filter is applied when induks are selected: the wilkers of one BKK
      // Induk can span several districts.
      const response = await BKKService.getAll(params);

      const bkkList = response.bkk || [];
      const wilkers = bkkList.filter(
        (item) =>
          item.induk_id && (!ids.length || ids.includes(item.induk_id))
      );

      setLevelDataOptions((prevState) => ({
        ...prevState,
        wilkers: wilkers.map((item) => {
          return {
            label: item.name,
            value: `${item.id}|${item.name}`,
          };
        }),
      }));
    } catch (error) {
      console.log(error);
    }
  };

  const generateLevelOptions = (userLevel) => {
    switch (userLevel) {
      case UserLevel.Fasyankes:
        return [{ label: "Fasyankes", value: UserLevel.Fasyankes }];
      case UserLevel.BKKWilker:
        return [{ label: "BKK Wilker", value: "wilker" }];
      case UserLevel.BKKInduk:
        return [
          { label: "BKK Induk", value: "induk" },
          { label: "BKK Wilker", value: "wilker" },
        ];
      case UserLevel.District:
        return [
          { label: "Kabupaten/Kota", value: UserLevel.District },
          { label: "Fasyankes", value: UserLevel.Fasyankes },
          { label: "BKK Induk", value: "induk" },
          { label: "BKK Wilker", value: "wilker" },
        ];
      case UserLevel.Province:
        return [
          { label: "Provinsi", value: UserLevel.Province },
          { label: "Kabupaten/Kota", value: UserLevel.District },
          { label: "Fasyankes", value: UserLevel.Fasyankes },
          { label: "BKK Induk", value: "induk" },
          { label: "BKK Wilker", value: "wilker" },
        ];
      default:
        return [
          { label: "Nasional", value: UserLevel.National },
          { label: "Provinsi", value: UserLevel.Province },
          { label: "Kabupaten/Kota", value: UserLevel.District },
          { label: "Fasyankes", value: UserLevel.Fasyankes },
          { label: "BKK Induk", value: "induk" },
          { label: "BKK Wilker", value: "wilker" },
        ];
    }
  };

  useEffect(() => {
    if (currentUser.level === UserLevel.District) {
      setSelectedFasyankes("");
    } else if (currentUser.level === UserLevel.Province) {
      setSelectedDistrict("");
      setSelectedFasyankes("");
    } else if (currentUser.level === UserLevel.National) {
      setSelectedProvince("");
      setSelectedDistrict("");
      setSelectedFasyankes("");
      setSelectedInduk("");
      setSelectedWilker("");
    } else if (currentUser.level === UserLevel.BKKInduk) {
      setSelectedWilker("");
    }
  }, [selectedLevel]);

  useEffect(() => {
    const isBkkFilter =
      selectedLevel === "induk" ||
      selectedLevel === "wilker" ||
      selectedLevel === UserLevel.BKKInduk ||
      selectedLevel === UserLevel.BKKWilker;

    if (isBkkFilter) {
      if (currentUser.level === UserLevel.BKKInduk) {
        setLevelIdValue(`${currentUser.username}|${currentUser.first_name}`);
      } else if (currentUser.level === UserLevel.BKKWilker) {
        setLevelIdValue(`${currentUser.username}|${currentUser.first_name}`);
      } else if (selectedLevel === "induk" && selectedInduk) {
        setLevelIdValue(selectedInduk);
      } else if (selectedLevel === "wilker" && selectedWilker) {
        setLevelIdValue(selectedWilker);
      }
      return;
    }

    if (currentUser.level === UserLevel.Fasyankes) {
      setLevelIdValue(currentUser?.fasyankes_id);
    } else if (currentUser.level === UserLevel.District) {
      setLevelIdValue(currentUser?.district_id);
    } else if (currentUser.level === UserLevel.Province) {
      setLevelIdValue(currentUser?.province_id);
    } else {
      setLevelIdValue("");
    }
  }, [selectedLevel]);

  useEffect(() => {
    fetchAllProvincies();

    if (selectedProvince) {
      fetchDistrictByProvince(selectedProvince?.split("|")[0]);
    }
    if (selectedDistrict) {
      fetchFasyankesByDistrict(selectedDistrict?.split("|")[0]);
    }
  }, [selectedProvince, selectedDistrict]);

  useEffect(() => {
    if (
      selectedLevel === UserLevel.BKKInduk ||
      selectedLevel === UserLevel.BKKWilker ||
      selectedLevel === "induk" ||
      selectedLevel === "wilker"
    ) {
      if (currentUser.level !== UserLevel.BKKWilker && currentUser.level !== UserLevel.BKKInduk) {
        fetchBKKInduk();
      }
    }
    if (
      selectedLevel === UserLevel.BKKWilker ||
      selectedLevel === "wilker"
    ) {
      if (currentUser.level === UserLevel.BKKWilker) {
        fetchBKKWilker(selectedInduk);
      } else if (
        currentUser.level === UserLevel.District ||
        currentUser.level === UserLevel.Province
      ) {
        fetchBKKWilker(selectedInduk);
      }
    }
  }, [selectedLevel, selectedProvince, selectedDistrict]);

  useEffect(() => {
    if (selectedInduk) {
      fetchBKKWilker(selectedInduk);
    }
  }, [selectedInduk]);

  useEffect(() => {
    const initData = async () => {
      const options = generateLevelOptions(currentUser.level);
      setLevelData(options);

      if (currentUser.level === UserLevel.BKKWilker) {
        setSelectedLevel("wilker");
        setLevelIdValue(`${currentUser.username}|${currentUser.first_name}`);
        const getBkk = await BKKService.getIndukByWilker(currentUser.username);
        if (getBkk) {
          setLevelDataOptions((prevState) => ({
            ...prevState,
            induks: [{ label: getBkk.induk_name, value: `${getBkk.induk_id}|${getBkk.induk_name}` }],
          }));
          setSelectedInduk(`${getBkk.induk_id}|${getBkk.induk_name}`);
        }
        setSelectedWilker(`${currentUser.username}|${currentUser.first_name}`);
      } else if (currentUser.level === UserLevel.BKKInduk) {
        setSelectedLevel("induk");
        setLevelIdValue(`${currentUser.username}|${currentUser.first_name}`);
        setLevelDataOptions((prevState) => ({
          ...prevState,
          induks: [{ label: currentUser.first_name, value: `${currentUser.username}|${currentUser.first_name}` }],
        }));
        setSelectedInduk(`${currentUser.username}|${currentUser.first_name}`);
      } else if (currentUser.level === UserLevel.Fasyankes) {
        setLevelIdValue(currentUser?.fasyankes_id);
      } else if (currentUser.level === UserLevel.District) {
        setLevelIdValue(currentUser?.district_id);
      } else if (currentUser.level === UserLevel.Province) {
        setLevelIdValue(currentUser?.province_id);
      } else {
        setLevelIdValue("");
      }
    };
    if (currentUser) initData();
  }, [currentUser]);

  // periode laporan inputan
  const renderPeriodeFilter = () => {
    switch (periodeLaporan) {
      case "yearly":
        return (
          <InputDate
            value={periodeLaporanValue}
            onChange={(e) => {
              const selectedYear = moment(e).format("YYYY");
              setPeriodeLaporanValue({ year: selectedYear });
            }}
            placeholder={"Pilih Tahun"}
            dateFormat={"YYYY"}
          />
        );
      case "monthly":
        return (
          <div style={{ display: "flex", flexDirection: "row", gap: "1.2rem" }}>
            <div style={{ flex: "1" }}>
              <InputDate
                value={periodeLaporanValue}
                onChange={(e) => {
                  const selectedYear = moment(e).format("YYYY");
                  setPeriodeLaporanValue((prevPeriode) => ({
                    ...prevPeriode,
                    year: selectedYear,
                  }));
                }}
                placeholder={"Pilih Tahun"}
                dateFormat={"YYYY"}
              />
            </div>
            <div style={{ flex: "1" }}>
              <InputSelect
                data={MonthOptions}
                isClearable={false}
                placeholder={"Bulan Mulai"}
                value={
                  MonthOptions.find(
                    (e) => e.value === periodeLaporanValue.month_start,
                  ) ?? ""
                }
                onChange={(e) => {
                  setPeriodeLaporanValue((prevPeriode) => {
                    const { month_end, ...rest } = prevPeriode;
                    return { ...rest, month_start: e.value };
                  });
                  setSelectedEnd("");
                }}
              />
            </div>
            <div style={{ flex: "1" }}>
              <InputSelect
                data={generateMonthOptions(periodeLaporanValue.month_start)}
                isClearable={false}
                placeholder={"Bulan Akhir"}
                onChange={(e) => {
                  setPeriodeLaporanValue((prevPeriode) => ({
                    ...prevPeriode,
                    month_end: e.value,
                  }));
                  setSelectedEnd(e.value);
                }}
                value={
                  generateMonthOptions(periodeLaporanValue.month_start)?.find(
                    (item) => item.value === selectedEnd,
                  ) || ""
                }
              />
            </div>
          </div>
        );
    }
  };

  // level options
  const renderLevelFilter = () => {
    switch (selectedLevel) {
      case UserLevel.Province:
        return (
          <div style={{ display: "flex", flexDirection: "row", gap: "1.2rem" }}>
            <div style={{ flex: "1" }}>
              <InputSelect
                isClearable={false}
                placeholder={"Pilih Provinsi"}
                data={levelDataOptions.provinces}
                onChange={(e) => {
                  setSelectedProvince(e.value);
                  setLevelIdValue(e.value);
                }}
                value={
                  levelDataOptions.provinces?.find(
                    (item) => item.value === selectedProvince
                  ) || ""
                }
                isDisabled={
                  currentUser.level === UserLevel.National ? false : true
                }
              />
            </div>
          </div>
        );
      case UserLevel.District:
        return (
          <div style={{ display: "flex", flexDirection: "row", gap: "1.2rem" }}>
            <div style={{ flex: "1" }}>
              <InputSelect
                isClearable={false}
                placeholder={"Pilih Provinsi"}
                data={levelDataOptions.provinces}
                onChange={(e) => {
                  setSelectedProvince(e.value);
                  setSelectedDistrict("");
                }}
                value={
                  levelDataOptions.provinces?.find(
                    (item) => item.value === selectedProvince
                  ) || ""
                }
                isDisabled={
                  currentUser.level === UserLevel.National ? false : true
                }
              />
            </div>
            <div style={{ flex: "1" }}>
              <InputSelect
                isClearable={false}
                placeholder={"Pilih Kab/Kota"}
                data={
                  currentUser?.level === UserLevel.District
                    ? levelDataOptions.districts?.filter(
                        (item) => item.value === currentUser?.district_id
                      )
                    : levelDataOptions.districts
                }
                onChange={(e) => {
                  setSelectedDistrict(e.value);
                  setLevelIdValue(e.value);
                }}
                value={
                  levelDataOptions.districts?.find(
                    (item) => item.value === selectedDistrict
                  ) || ""
                }
                isDisabled={
                  currentUser.level === UserLevel.National ||
                  currentUser.level === UserLevel.Province
                    ? false
                    : true
                }
              />
            </div>
          </div>
        );
      case UserLevel.Fasyankes:
        return (
          <div style={{ display: "flex", flexDirection: "row", gap: "1.2rem" }}>
            <div style={{ flex: "1" }}>
              <InputSelect
                isClearable={false}
                placeholder={"Pilih Provinsi"}
                data={levelDataOptions.provinces}
                onChange={(e) => {
                  setSelectedProvince(e.value);
                  setSelectedFasyankes("");
                  setSelectedDistrict("");
                }}
                value={
                  levelDataOptions.provinces?.find(
                    (item) => item.value === selectedProvince
                  ) || ""
                }
                isDisabled={
                  currentUser?.level === UserLevel.National ? false : true
                }
              />
            </div>
            <div style={{ flex: "1" }}>
              <InputSelect
                isClearable={false}
                placeholder={"Pilih Kab/Kota"}
                data={levelDataOptions.districts}
                onChange={(e) => {
                  setSelectedDistrict(e.value);
                  setSelectedFasyankes("");
                }}
                value={
                  levelDataOptions.districts?.find(
                    (item) => item.value === selectedDistrict
                  ) || ""
                }
                isDisabled={
                  currentUser?.level === UserLevel.National ||
                  currentUser?.level === UserLevel.Province
                    ? false
                    : true
                }
              />
            </div>
            <div style={{ flex: "1" }}>
              <InputSelect
                isClearable={false}
                isMultipleSelect={true}
                placeholder={"Pilih Fasyankes"}
                data={
                  currentUser.level === UserLevel.Fasyankes
                    ? levelDataOptions.fasyankes?.filter(
                        (item) => item.value === currentUser?.fasyankes_id
                      )
                    : levelDataOptions.fasyankes
                }
                onChange={(e) => {
                  let value = e.map(function (item) {
                    return item.value;
                  });
                  let resultValue = value.join(",");
                  setSelectedFasyankes(resultValue);
                  setLevelIdValue(resultValue);
                }}
                value={levelDataOptions.fasyankes?.filter((item) =>
                  selectedFasyankes?.includes(item.value)
                )}
                isDisabled={
                  currentUser?.level === UserLevel.National ||
                  currentUser?.level === UserLevel.Province ||
                  currentUser?.level === UserLevel.District
                    ? false
                    : true
                }
              />
            </div>
          </div>
        );
      case UserLevel.BKKInduk:
      case "induk":
        return (
          <div style={{ display: "flex", flexDirection: "row", gap: "1.2rem", zIndex: 11 }}>
            <div style={{ flex: "1" }}>
              <InputSelect
                isClearable={false}
                placeholder={"Pilih BKK Induk"}
                data={levelDataOptions.induks}
                onChange={(e) => {
                  const value = Array.isArray(e)
                    ? e.map((item) => item.value).join(",")
                    : e.value;
                  setSelectedInduk(value);
                  setLevelIdValue(value);
                  setSelectedWilker("");
                }}
                value={
                  currentUser.level === UserLevel.National
                    ? levelDataOptions.induks?.filter((item) =>
                        selectedInduk?.includes(item.value)
                      )
                    : levelDataOptions.induks?.find(
                        (item) => item.value === selectedInduk
                      ) || ""
                }
                isMultipleSelect={currentUser.level === UserLevel.National}
                isDisabled={
                  currentUser.level === UserLevel.National ||
                  currentUser.level === UserLevel.Province ||
                  currentUser.level === UserLevel.District ||
                  currentUser.level === UserLevel.BKKInduk
                    ? false
                    : true
                }
              />
            </div>
          </div>
        );
      case UserLevel.BKKWilker:
      case "wilker":
        return (
          <div style={{ display: "flex", flexDirection: "row", gap: "1.2rem" }}>
            <div style={{ flex: "1" }}>
              <InputSelect
                isClearable={false}
                placeholder={"Pilih BKK Induk"}
                data={levelDataOptions.induks}
                onChange={(e) => {
                  setSelectedInduk(e.value);
                  setSelectedWilker("");
                  setLevelIdValue("");
                }}
                value={
                  levelDataOptions.induks?.find(
                    (item) => item.value === selectedInduk
                  ) || ""
                }
                isDisabled={
                  currentUser.level === UserLevel.National ||
                  currentUser.level === UserLevel.Province ||
                  currentUser.level === UserLevel.District
                    ? false
                    : true
                }
              />
            </div>
            <div style={{ flex: "1" }}>
              <InputSelect
                isClearable={false}
                placeholder={"Pilih BKK Wilker"}
                data={
                  currentUser.level === UserLevel.BKKWilker
                    ? levelDataOptions.wilkers?.filter(
                        (item) => item.value === `${currentUser.username}|${currentUser.first_name}`
                      )
                    : levelDataOptions.wilkers
                }
                onChange={(e) => {
                  let value = e.map(function (item) {
                    return item.value;
                  });
                  let resultValue = value.join(",");
                  setSelectedWilker(resultValue);
                  setLevelIdValue(resultValue);
                }}
                value={levelDataOptions.wilkers?.filter((item) =>
                  selectedWilker?.includes(item.value)
                )}
                isMultipleSelect={true}
                isDisabled={
                  currentUser.level === UserLevel.National ||
                  currentUser.level === UserLevel.Province ||
                  currentUser.level === UserLevel.District ||
                  currentUser.level === UserLevel.BKKInduk ||
                  levelDataOptions.wilkers?.length > 0
                    ? false
                    : true
                }
              />
            </div>
          </div>
        );
    }
  };

  const handleApplyFilter = async ({ isExport = false, page }) => {
    const normalizedLevel =
      selectedLevel === UserLevel.BKKInduk
        ? "induk"
        : selectedLevel === UserLevel.BKKWilker
          ? "wilker"
          : selectedLevel.toLowerCase();
    const params = {
      level: normalizedLevel,
      level_id: levelIdValue,
      period: periodeLaporan,
      ...periodeLaporanValue,
      page: page ?? 1,
    };
    try {
      if (isExport) {
        setIsDownloading(true);
        await LaporanService.Regmal1Excel(params)
          .then((excelData) => {
            const url = window.URL.createObjectURL(new Blob([excelData]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute(
              "download",
              `LAPORAN_REGMAL_1_${
                params.level == "national"
                  ? "Nasional"
                  : params.level_id?.split("|")[1]
              }_${params.period === "monthly"
                  ? `${params.year}-${params.month_end && params.month_end !== params.month_start ? params.month_start + "_" + params.year + "-" + params.month_end : params.month_start}`
                  : params.year}.xlsx`
            );
            document.body.appendChild(link);
            link.click();
            setIsDownloading(false);
          })
          .catch((err) => {
            console.log(err);
            setIsDownloading(false);
          });
        return;
      } else {
        setIsLoading(true);
        setShowData(false);
        const response = await LaporanService.Regmal1(params);
        setReportInfo({
          statusPeriode: periodeLaporan,
          periode: periodeLaporanValue,
          province: selectedProvince,
          district: selectedDistrict,
          fasyankes: selectedFasyankes,
          bkk: params.level === "induk" ? selectedInduk : params.level === "wilker" ? (selectedWilker || selectedInduk) : "",
        });
        setReportData(response);
        setCurrentLevel(params.level);
      }
    } catch (error) {
      console.log(error);
      setReportData([]);
    } finally {
      setIsLoading(false);
      if (!isExport) setShowData(true);
    }
  };

  return (
    <div className="dashboard-wrapper">
      <BreadcrumbNav
        items={[
          { label: "Laporan", onClick: () => history.push("/laporan") },
          { label: module },
        ]}
      />
      <div className="filter" style={{ position: "relative", zIndex: 10 }}>
        <div className="filter-header">
          <p>FILTER</p>
          <button
            className="btn_toggle_filter"
            onClick={() => setShowFilter(!showFilter)}
          >
            {showFilter ? <ArrowUp size={18} /> : <ArrowDown size={18} />}
          </button>
        </div>
        {showFilter && (
          <div className="filter-body">
            <div className="filter-item">
              <div className="filter-label">
                <p>Periode Laporan</p>
              </div>
              <div className="filter-field">
                <InputRadio
                  isRequired={true}
                  options={[
                    { label: "Tahunan", value: "yearly" },
                    { label: "Bulanan", value: "monthly" },
                  ]}
                  onChange={(e) => {
                    setPeriodeLaporan(e.target.value);
                    setPeriodeLaporanValue("");
                    setSelectedEnd("");
                  }}
                  selectedOption={periodeLaporan}
                />
                <div className="advanced-filter">{renderPeriodeFilter()}</div>
              </div>
            </div>
            <div className="filter-item">
              <div className="filter-label">
                <p>Level</p>
              </div>
              <div className="filter-field">
                <InputRadio
                  options={levelData}
                  onChange={(e) => {
                    setSelectedLevel(e.target.value);

                    const isBkkLevel =
                      e.target.value === "induk" || e.target.value === "wilker";
                    const isBkkInduk =
                      e.target.value === "induk" &&
                      currentUser.level === UserLevel.BKKInduk;
                    const isBkkWilker =
                      e.target.value === "wilker" &&
                      currentUser.level === UserLevel.BKKWilker;

                    if (isBkkLevel && !isBkkInduk && !isBkkWilker) {
                      if (e.target.value === "induk" && selectedInduk) {
                        setLevelIdValue(selectedInduk);
                      } else if (e.target.value === "wilker" && selectedWilker) {
                        setLevelIdValue(selectedWilker);
                      } else {
                        setLevelIdValue("");
                      }
                    } else if (e.target.value != currentUser.level && !isBkkInduk && !isBkkWilker) {
                      setLevelIdValue("");
                    } else {
                      if (currentUser.level === UserLevel.Fasyankes) {
                        setLevelIdValue(currentUser?.fasyankes_id);
                      } else if (currentUser.level === UserLevel.District) {
                        setLevelIdValue(currentUser?.district_id);
                      } else if (currentUser.level === UserLevel.Province) {
                        setLevelIdValue(currentUser?.province_id);
                      } else if (currentUser.level === UserLevel.BKKInduk) {
                        setLevelIdValue(`${currentUser.username}|${currentUser.first_name}`);
                      } else if (currentUser.level === UserLevel.BKKWilker) {
                        setLevelIdValue(`${currentUser.username}|${currentUser.first_name}`);
                      } else {
                        setLevelIdValue("");
                      }
                    }
                  }}
                  selectedOption={selectedLevel}
                />
                <div className="advanced-filter">{renderLevelFilter()}</div>
              </div>
            </div>
            <div className="filter-item">
              <div className="filter-field">
                <div className="filter-condition">
                  <Button
                    variant={"primary"}
                    size={"normal"}
                    onClick={() => handleApplyFilter({ isExport: false })}
                    isDisabled={
                      !selectedLevel ||
                      !periodeLaporan ||
                      !periodeLaporanValue ||
                      (periodeLaporan === "monthly" &&
                        (!periodeLaporanValue?.month_start ||
                          !periodeLaporanValue?.month_end)) ||
                      (selectedLevel.toLowerCase() !== "national" &&
                        !levelIdValue)
                    }
                  >
                    Terapkan
                  </Button>
                  <Button
                    variant={"secondary"}
                    size={"normal"}
                    onClick={() => handleApplyFilter({ isExport: true })}
                    isDisabled={isDownloading}
                  >
                    Export Excel
                    {isDownloading ? "..." : ""}
                  </Button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>

      {/* loading spinner */}
      {isLoading && !showData && (
        <div
          style={{
            display: "flex",
            width: "100%",
            justifyContent: "center",
            marginTop: "5rem",
          }}
        >
          <HashLoader size={100} color="#18b3ab" />
        </div>
      )}

      {showData && (
        <div className="table-container">
          <div className="data-title">
            <h2>{module}</h2>
          </div>
          <div className="data-main">
            {reportData && (
              <TableComponent
                currentLevel={currentLevel}
                reportsData={reportData.regmals}
                tableRef={tableRef}
                reportInfo={reportInfo}
                paginationData={{
                  total: reportData?.total,
                  limit: reportData?.limit,
                  nextPage: reportData?.nextPage,
                  currentPage: reportData?.currentPage,
                }}
              />
            )}
            {reportData && (
              <Pagination
                style={{ marginTop: "1rem" }}
                totalRecords={reportData?.total}
                pageLimit={reportData?.limit}
                currentPage={reportData?.currentPage}
                onPageChange={(page) => {
                  handleApplyFilter({
                    page: page,
                    isExport: false,
                  });
                }}
              />
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default DetailLaporan;
